/**
 * Sayfa değişince iptal edilecek istekler (router `requestQueue/abortAll`).
 * TKP-254: iptal belirteçleri reaktif durumda DEĞİL, düz bir kümede tutulur ve istek bitince kümeden çıkar. Eskiden her istek
 * belirtecini reaktif diziye ekliyordu (Vue nesneyi gözlüyor, her biri bir mutasyon) ve dizi sayfa değişene kadar büyüyordu —
 * kalabalık birimde 1186 adımlık toplu işlem kaydı bu yüzden ~9 sn ekranı donduruyordu.
 * (Ayrı dosyada: store yükleyicisi `store/` altındaki her adlandırılmış dışa aktarımı Vuex modülü sayar.)
 */
const live = new Set();

/** rest-client: isteğin iptal belirteci kaydedilir / istek bitince çıkarılır. */
export const trackRequest = (source) => {
  if (source) live.add(source);
  return source;
};
export const releaseRequest = (source) => {
  if (source) live.delete(source);
};
export const liveRequests = () => Array.from(live);
/** Bekleyen her isteği iptal eder ve kümeyi boşaltır. */
export const abortAllRequests = () => {
  live.forEach((c) => c.cancel());
  live.clear();
};
